module.exports = __webpack_public_path__ + "img/mentor5.7b4165b.jpg";